import { getTotalAllocated } from '@/app/common/components/purse_allocation_form/purse_allocation.utils'
import { currencyFormatter } from '@/app/common/utilities'
import { PursesArray } from '@/schemas/provider.schema'
import { z } from 'zod'

// Schema using purses with id, amount, and isSelected properties
export const createPurseFormSchema = (
  apiPurses: PursesArray,
  paymentAmount: number
) => {
  return z.object({
    purses: z
      .array(
        z.object({
          purse_id: z.number().int().positive(),
          amount: z.number({
            message: 'Enter a valid amount or select a different purse',
          }),
          isSelected: z.boolean(),
          name: z.string(),
          hasBeenManuallyEdited: z.boolean()
        })
      )
      .superRefine((purses, ctx) => {
        // Check that at least one purse is selected
        const selectedPurses = purses.filter((purse) => purse.isSelected)

        if (selectedPurses.length === 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Please select at least one purse',
            path: ['root'],
          })
          return
        }

        // Calculate total allocated amount
        const totalAllocated = getTotalAllocated(selectedPurses)


        // Check if the total allocated amount matches the payment amount
        if (totalAllocated !== paymentAmount) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Total allocated amount must exactly match ${currencyFormatter.format(paymentAmount)}`,
            path: ['root'],
          })
        }

        // Validate each selected purse's amount
        purses.forEach((item, index) => {
          if (!item.isSelected) return // Skip validation for unselected purses

          const apiPurse = apiPurses.find((p) => p.id === item.purse_id)

          if (!apiPurse) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Invalid purse selected',
              path: [index, 'purse_id'],
            })
            return
          }

          // Check if amount is provided for selected purse
          if (!item.amount || item.amount <= 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Amount must be greater than zero',
              path: [index, 'amount'],
            })
          } else if (item.amount > apiPurse.balance_available) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: `Amount cannot exceed the purse balance of ${currencyFormatter.format(apiPurse.balance_available)}`,
              path: [index, 'amount'],
            })
          }
        })
      }),
  })
}
